import React from "react";
import styled from "styled-components";
import {Container} from "@mui/material";
import ArticleCard from "./ArticleCard";
import Link from "next/link";
import { useRouter } from "next/router";
import { Card as CardType } from "../../types";

const StyledContainer = styled(Container)`
  min-height: 400px;
  position: relative;
  text-align: center;
`;
const BlogLink = styled.div`
  color: #e55934;
  font-size: 1.5rem;
  font-weight: 800;
  margin: 1em 0;
`;
interface FeedProps {
  posts: CardType[];
}
const ArticleFeed: React.FunctionComponent<FeedProps>  = ({ posts }) => {
  const router = useRouter();

  return (
    <StyledContainer>
      {posts &&
        posts.map((post, i) => <ArticleCard key={`post_${i}`} card={post} />)}
      {router.asPath && router.asPath !== "/blog" && (
        <BlogLink>
          <Link href="/blog">
            <span>See all articles</span>
          </Link>{" "}
        </BlogLink>
      )}
    </StyledContainer>
  );
};
export default ArticleFeed;
